(function() {
  document.querySelectorAll('.lh-tabs').forEach(function(specs) {
    specs.querySelectorAll('.lh-tabs__btn').forEach(function(btn) {
      btn.addEventListener('click', function() {
        specs.querySelectorAll('.lh-tabs__btn').forEach(function(b) { b.classList.remove('is-active'); });
        specs.querySelectorAll('.lh-tabs__panel').forEach(function(p) { p.classList.remove('is-active'); });
        btn.classList.add('is-active');
        specs.querySelector('#lh-tab-' + btn.dataset.tab).classList.add('is-active');
      });
    });
  });
})();
(function () {
  document.querySelectorAll('.lh-feature-strip__inner').forEach(function (el) {
    var isDown = false;
    var startX;
    var scrollLeft;

    el.addEventListener('mousedown', function (e) {
      isDown = true;
      el.style.cursor = 'grabbing';
      startX = e.pageX - el.offsetLeft;
      scrollLeft = el.scrollLeft;
      e.preventDefault();
    });

    el.addEventListener('mouseleave', function () {
      isDown = false;
      el.style.cursor = 'grab';
    });

    el.addEventListener('mouseup', function () {
      isDown = false;
      el.style.cursor = 'grab';
    });

    el.addEventListener('mousemove', function (e) {
      if (!isDown) return;
      var x = e.pageX - el.offsetLeft;
      var walk = (x - startX) * 1.5;
      el.scrollLeft = scrollLeft - walk;
    });

    // cursor inițial
    el.style.cursor = 'grab';
  });
})();
document.addEventListener('click', function(e) {
  var btn = e.target.closest('.lh-expand__btn');
  if (!btn) return;
  var wrap = btn.closest('.lh-expand');
  if (!wrap) return;
  var isOpen = wrap.getAttribute('data-expand') === 'open';
  wrap.setAttribute('data-expand', isOpen ? 'closed' : 'open');
  btn.textContent = isOpen
    ? (btn.dataset.labelMore || 'Citește mai mult')
    : (btn.dataset.labelLess || 'Citește mai puțin');
});